import { render, staticRenderFns } from "./warranty.vue?vue&type=template&id=6e23dc47&scoped=true"
import script from "./warranty.vue?vue&type=script&lang=js"
export * from "./warranty.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e23dc47",
  null
  
)

export default component.exports